var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCiudad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1219",
    "data-name": "Group 1219",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.758,
    height: 29.74,
    viewBox: "0 0 29.758 29.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fafafa;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_730",
    "data-name": "Rectangle 730",
    className: "cls-1",
    width: 29.758,
    height: 29.74
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1209",
    "data-name": "Group 1209",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    className: "cls-1",
    d: "M0,15.846q0-6.62,0-13.24c0-.5.154-.654.666-.652.495,0,.99,0,1.484.017.168.006.212-.042.207-.205-.012-.371-.017-.743,0-1.113C2.376.2,2.552,0,3.01,0c3.7.013,7.4.008,11.1.008.5,0,.666.17.669.663,0,.34.013.681,0,1.021-.011.22.038.305.283.3.752-.024,1.505-.019,2.258-.028.659-.008.806.133.805.779,0,1.629,0,3.258,0,4.888,0,.21.025.315.277.309.232,0,.3-.068.291-.3-.019-.36-.006-.722,0-1.082a.51.51,0,0,1,.48-.6,1.458,1.458,0,0,1,.277-.013c2.866,0,5.733.005,8.6,0,.622,0,.9.194.845.856-.024.3,0,.6-.009.9-.006.164.032.233.216.24.552.02.663.144.663.686q0,10.224,0,20.448c0,.494-.143.636-.642.636q-8.414,0-16.827,0c-1.6,0-3.2.056-4.793.026-2.3-.044-4.6-.009-6.9-.028-.442,0-.6-.163-.6-.618q0-6.62,0-13.24m17.137,0q0-6.311.006-12.622c0-.26-.069-.32-.325-.319q-7.764.013-15.529,0c-.3,0-.37.086-.37.379Q.934,9.24.925,15.2q0,6.651-.005,13.3c0,.242.069.286.294.285q2.521-.014,5.042,0c.228,0,.306-.054.289-.3-.088-1.287-.026-2.576-.036-3.865a.528.528,0,0,1,.59-.6q1.949-.017,3.9,0c.418,0,.571.182.571.592,0,1.289.008,2.578-.007,3.867,0,.25.064.306.305.3q2.459-.016,4.918,0c.272,0,.36-.052.359-.347q-.016-6.3-.007-12.591m11.631,3.03h0c0-3.217,0-6.435.006-9.652,0-.261-.068-.318-.322-.317q-4.98.012-9.961,0c-.291,0-.375.058-.375.363q.015,9.621,0,19.242c0,.216.051.279.27.275q1.376-.023,2.753-.011c.233,0,.3-.066.294-.3-.013-.9-.009-1.794,0-2.691,0-.547.179-.715.723-.714h2.568c.584,0,.75.179.743.753-.01.876,0,1.753-.01,2.629,0,.246.067.336.331.331q1.33-.025,2.66,0c.252,0,.328-.054.327-.317q-.014-4.8-.006-9.59M10.641,26.892c0-.557-.006-1.114,0-1.67,0-.175-.05-.233-.226-.232q-1.361.01-2.722,0c-.186,0-.216.077-.216.239q.007,1.67,0,3.341c0,.161.041.213.206.212.907-.007,1.815-.008,2.722,0,.2,0,.24-.072.236-.252-.01-.546,0-1.093,0-1.639M8.568,1.929v0h4.574c.685,0,.677,0,.684-.681,0-.248-.067-.326-.329-.325-3.152.011-6.3.007-9.456.008-.708,0-.7,0-.706.708,0,.228.055.294.289.293,1.648-.011,3.3-.006,4.944-.006m15.19,6h3.463c.683,0,.672,0,.687-.69.005-.239-.05-.308-.3-.307-2.432.01-4.864.006-7.3.006-.71,0-.7,0-.708.7,0,.265.1.3.321.294,1.278-.009,2.556,0,3.834,0M22.4,27.384c0,.361.011.722,0,1.083-.008.2.049.272.254.268.546-.012,1.093-.015,1.639,0,.182.005.225-.047.223-.217q-.008-1.129,0-2.258c0-.166-.058-.211-.215-.209-.557.007-1.114.01-1.67,0-.2,0-.242.07-.235.252.013.361,0,.722,0,1.083",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    className: "cls-1",
    d: "M27.335,121.719c0-.412.008-.824,0-1.236,0-.173.048-.227.223-.235.726-.032.723-.038.73.684.006.679-.035,1.359.023,2.037.013.15-.037.194-.184.2-.785.055-.785.059-.785-.714v-.741Z",
    transform: "translate(-23.932 -105.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    className: "cls-1",
    d: "M27.351,161.621c0-.421,0-.843,0-1.264,0-.156.047-.213.21-.221.734-.039.732-.044.74.684.007.678-.035,1.357.025,2.033.014.159-.055.186-.193.195-.777.048-.777.051-.776-.718q0-.355,0-.709Z",
    transform: "translate(-23.947 -140.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    className: "cls-1",
    d: "M28.3,41.786c0,.421-.006.843,0,1.264,0,.148-.04.188-.189.194-.77.032-.77.037-.77-.731,0-.638,0-1.275-.006-1.913,0-.182.05-.251.241-.26.716-.031.715-.038.712.674,0,.257,0,.514,0,.771H28.3",
    transform: "translate(-23.937 -35.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    className: "cls-1",
    d: "M110.3,41.823c0-.411.006-.822,0-1.232,0-.175.058-.228.231-.234.712-.024.712-.03.712.693,0,.647-.012,1.294,0,1.941,0,.223-.07.271-.279.27-.666,0-.666,0-.666-.668q0-.385,0-.77Z",
    transform: "translate(-96.58 -35.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    className: "cls-1",
    d: "M111.21,121.712c0,.4-.007.8,0,1.2,0,.174-.023.252-.23.253-.707.005-.707.015-.709-.7,0-.669.006-1.339-.007-2.008,0-.165.04-.21.2-.218.74-.037.74-.042.74.695v.772Z",
    transform: "translate(-96.555 -105.28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    className: "cls-1",
    d: "M70.049,121.835c0,.411-.009.822,0,1.233.006.183-.06.218-.228.221-.7.012-.7.018-.7-.677,0-.658.007-1.315,0-1.973,0-.191.038-.264.249-.268.682-.011.682-.021.682.662v.8Z",
    transform: "translate(-60.524 -105.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    className: "cls-1",
    d: "M70.057,161.652c0,.412,0,.823,0,1.235,0,.074.046.2-.067.205a7.4,7.4,0,0,1-.771,0c-.1,0-.083-.1-.083-.169,0-.844,0-1.688,0-2.532,0-.148.051-.188.2-.194.734-.03.734-.034.734.711q0,.37,0,.741Z",
    transform: "translate(-60.534 -140.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    className: "cls-1",
    d: "M111.263,161.679c0,.412,0,.824,0,1.235,0,.137-.024.195-.182.2-.759.038-.76.044-.76-.711,0-.659.01-1.318,0-1.976,0-.183.06-.223.229-.227.712-.015.711-.02.71.673,0,.268,0,.535,0,.8Z",
    transform: "translate(-96.603 -140.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    className: "cls-1",
    d: "M70.045,41.947c0,.392-.009.783,0,1.175.006.182-.034.247-.235.246-.7,0-.7.006-.7-.689,0-.649.006-1.3,0-1.948,0-.186.05-.248.241-.254.691-.023.691-.03.691.665v.8Z",
    transform: "translate(-60.519 -35.438)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    className: "cls-1",
    d: "M27.3,81.727V80.583c0-.062-.025-.149.006-.182.243-.255.551-.071.828-.1.185-.022.127.124.125.236-.013.793-.04,1.587.009,2.379.011.179-.01.257-.218.258-.748,0-.748.012-.747-.732q0-.356,0-.711Z",
    transform: "translate(-23.893 -70.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    className: "cls-1",
    d: "M110.28,81.832c0-.4.01-.8,0-1.206-.007-.186.035-.254.234-.255.7,0,.7-.008.7.694,0,.65-.005,1.3.007,1.948,0,.2-.052.26-.26.255-.682-.018-.682-.009-.682-.694q0-.371,0-.742h0",
    transform: "translate(-96.56 -70.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    className: "cls-1",
    d: "M70.044,81.905c0,.4-.006.8,0,1.206,0,.163-.049.206-.212.207-.717,0-.718.01-.718-.7,0-.639.006-1.278,0-1.917,0-.182.041-.247.236-.255.7-.028.7-.036.7.657v.8Z",
    transform: "translate(-60.519 -70.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    className: "cls-1",
    d: "M164.632,124.841c0,.4,0,.8,0,1.2,0,.15-.028.215-.2.222-.786.031-.785.037-.785-.748,0-.638.005-1.276,0-1.915,0-.176.029-.249.231-.254.747-.021.747-.029.746.719v.772Z",
    transform: "translate(-143.293 -108.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    className: "cls-1",
    d: "M164.634,164.747c0,.4-.006.8,0,1.2,0,.165-.035.231-.219.235-.769.017-.769.025-.768-.731,0-.627.007-1.253,0-1.88,0-.2.045-.292.271-.294.709-.005.709-.014.709.7q0,.385,0,.771Z",
    transform: "translate(-143.295 -142.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    className: "cls-1",
    d: "M164.627,84.846c0,.391,0,.783,0,1.174,0,.168-.043.231-.229.23-.755-.007-.755,0-.755-.759,0-.618.006-1.236,0-1.854,0-.181.043-.248.236-.261.745-.047.745-.054.746.7q0,.386,0,.773h0",
    transform: "translate(-143.291 -72.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    className: "cls-1",
    d: "M204.987,124.666c0-.411.009-.822,0-1.233-.006-.176.05-.245.221-.238.225.009.491-.061.667.036.227.124.032.4.044.614.038.686-.026,1.376.042,2.063.016.164-.054.208-.211.215-.75.033-.75.037-.75-.716q0-.37,0-.74h-.008",
    transform: "translate(-179.491 -107.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    className: "cls-1",
    d: "M205,164.576c0-.412.006-.824,0-1.236,0-.158.048-.214.209-.225.73-.048.726-.052.733.65.006.679-.035,1.359.03,2.037.015.156-.035.215-.2.223-.761.037-.761.043-.761-.709v-.741H205",
    transform: "translate(-179.505 -142.814)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    className: "cls-1",
    d: "M205.493,86.109c-.474-.008-.473-.008-.474-.471,0-.72,0-1.44-.009-2.159,0-.19.053-.252.237-.262.7-.038.7-.042.7.652.006.678-.039,1.357.029,2.034.017.172-.054.22-.209.208-.092-.007-.185,0-.277,0",
    transform: "translate(-179.514 -72.855)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCiudad);
export default __webpack_public_path__ + "static/media/Icon_Ciudad.51acc98e7c3dda151eca7cc0e2c8dc05.svg";
export { ForwardRef as ReactComponent };